import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import {Item} from "../../models/Item";
import {ObjectConfig} from "../../models/ObjectConfig";
import {ItemManagerService} from "../../services/itemManager/item-manager.service";
import {UiAdapterService} from "../../services/uiAdapterService/ui-adapter.service";
import {Subscription} from "rxjs";
declare var Yiit;

@Component({
  selector: 'app-fixed-size',
  templateUrl: './fixed-size.component.html',
  styleUrls: ['./fixed-size.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FixedSizeComponent implements OnInit, OnDestroy{

  @Input() item:Item;
  @Output() visibilityChanged: EventEmitter<boolean> = new EventEmitter();
  public isVisible = false;
  public mainVisibility = true;
  public zoomConfig = window['FIGURE_ZOOM_CONFIG'];
  public currentZoom = null;
  public isZoomNotPrev = false;
  private zoomInput = null;
  public Yiit = Yiit;
  protected subscribers: Subscription;

  constructor(private itemManager: ItemManagerService, protected cd: ChangeDetectorRef, private ui: UiAdapterService) {}

  ngOnInit() {
    this.subscribers = new Subscription();

    if (this.item.config.getToolParam('fixed-size-disabled')){
      this.mainVisibility = false;
      this.visibilityChanged.emit(this.mainVisibility && this.isVisible);
      this.cd.detectChanges();
    }

    this.subscribers.add(this.ui.selectedItem$.subscribe((selectedItem)=>{
      if (selectedItem instanceof Item){
        this.item = selectedItem;
        this.mainVisibility = (!this.item.config.getToolParam('fixed-size-disabled') && !this.item.config.getInputByName('fixed_width') && !this.item.config.getInputByName('fixedWidth'));
        this.initZoom();
        this.visibilityChanged.emit(this.mainVisibility && this.isVisible);
        this.isAllZoomsEqual();
        this.cd.detectChanges();
      }
    }));

    this.subscribers.add(this.item.config.serverUpdate.subscribe(()=>{
      this.updateCurrentZoom();
      this.cd.detectChanges();
    }));

    this.subscribers.add(this.item.config.subject.subscribe(()=>{
      this.updateCurrentZoom();
      this.cd.detectChanges();
    }));


    if (this.item.config.getObjectConfig().hasFixedSize()){
      this.isVisible = true;
      this.visibilityChanged.emit(this.mainVisibility && this.isVisible);
      this.cd.detectChanges();
      this.initZoom();
      return;
    }

    this.initZoom();
  }

  ngOnDestroy(): void {
    this.cd.detach();
    this.subscribers.unsubscribe();
  }

  private initZoom(){
    if (this.item.config.getObjectConfig().getToolType() == ObjectConfig.TYPE_FIXED_FIGURE){
      this.zoomInput = this.item.config.getInputByName('__figure_zoom');
      if (!this.zoomInput){
        this.item.config.createInputValue('__figure_zoom', {value: 1});
        this.zoomInput = this.item.config.getInputByName('__figure_zoom');
      }
      this.isVisible = true;
      this.currentZoom = this.zoomInput.value;
    }
    else{
      this.isVisible = false;
    }
    this.visibilityChanged.emit(this.mainVisibility && this.isVisible);
    this.cd.detectChanges();
  }

  getToolName(){
    return this.item.config.getTool().name;
  }

  updateCurrentZoom(){
    this.currentZoom = this.item.config.getInputProp('__figure_zoom', 'value');
    this.cd.detectChanges();
  }

  setFixedSize(zoom){
    if (!this.zoomInput || this.zoomInput.value==zoom){ return;}
    if (this.currentZoom != zoom){
      // this.item.config.setInputValue('__figure_zoom', 'prev_zoom', this.currentZoom);
      this.currentZoom = zoom;

      this.item.config.setInputValue('__figure_zoom', 'value', this.currentZoom);

      this.isAllZoomsEqual();

      this.cd.detectChanges();
    }
  }


  public isAllZoomsEqual(): boolean {
    let self = this;
    let items:Item[] = this.itemManager.getItemsByToolId(this.item.config.getToolId())
        .filter(item => item.getId() != self.item.getId());

    let isAllZoomsEqual = items.every(item => item.config.getInputProp('__figure_zoom', 'value') === this.currentZoom);

    this.isZoomNotPrev = !isAllZoomsEqual;

    return isAllZoomsEqual;
  }

  applyToOther(){
    let self = this;
    let items:Item[] = this.itemManager.getItemsByToolId(this.item.config.getToolId()).filter(item=>item.getId() != self.item.getId());
    items.forEach((item)=>{
      item.config.setInputValue('__figure_zoom', 'value', this.currentZoom);
    });
    this.isZoomNotPrev = false;
    this.cd.detectChanges();
  }

    public getItemsCount(): number {
      let self = this;
      let items:Item[] = this.itemManager.getItemsByToolId(this.item.config.getToolId())
          .filter(item => item.getId() != self.item.getId());

      let count = items.filter(item => item.config.getInputProp('__figure_zoom', 'value') !== this.currentZoom).length;

      return count;
  }

}
